import { resources } from '@api'
import MainContainer from '@blocks/MainContainer'
import { notify, route } from '@helpers'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import React from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import { useHistory } from 'react-router-dom'
import ClubForm from './Form'

export default function ClubAdd() {
    const auth = useAuth()

    const history = useHistory()
    useTitle("Group: Create")

    const handleSuccess = (response: { club: Resources.Club, membership: Resources.Membership }) => {
        unstable_batchedUpdates(() => {
            auth.set('club', response.club)
            auth.set('membership', response.membership)    
        })

        history.push(route("club:customer", response.club.id))
        notify("Thank you, the group was created.")
    }

    return (
        <MainContainer heading="Create a group">
            <ClubForm 
                method="post"
                action={resources.clubs}
                handleSuccess={handleSuccess} />
        </MainContainer>
    )
}